import { useSearchParams } from 'react-router';
import LayoutAdmin from '../../../components/layouts/LayoutAdmin';
import ListOther from './ListOtherProduct';
import FormOther from './FormOtherProduct';

export default function Other() {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'list';

  return (
    <div>
      {activeTab === 'list' && <ListOther />}
      {activeTab === 'form' && <FormOther />}
    </div>
  );
}
